// import { actionTypes as appStateActionTypes } from "../appState/actions";
import { immutableRecords } from "../../types";
import { actionTypes } from "./actions";

const reducer = (state = immutableRecords.AutoUpdatesRecord(), action) => {
  switch (action.type) {
    case actionTypes.LOAD_AUTO_UPDATES:
      // Changed to merge in the changes so unaffected values remain the same
      return state.merge(action.data);
    case actionTypes.SHOW_UPDATE_MODAL:
      return state.set("showUpdateModal", true);
    case actionTypes.HIDE_UPDATE_MODAL:
      return state.set("showUpdateModal", false);
    case actionTypes.SHOW_UPDATE_CHECK:
      return state.set("showUpdateModal", true).set("isChecking", true);
    // case appStateActionTypes.CHANGE_NOTIFICATION_TAB:
    //   return state.set("isReleaseNotesNew", false);
    // case actionTypes.HIDE_RELEASE_NOTES:
    //   return state.set("isReleaseNotesNew", false);
    default:
      return state;
  }
};

export default reducer;
